import { Validator } from 'vee-validate'
import NameInput from './name'
import EntryInput from './entry'
import UnitNo from './unitNo'
import MaskDecimal from './maskDecimal'
import MaskMinValue from './maskMinValue'
import MaskMaxValue from './maskMaxValue'
import FromToDate from './fromToDate'
import AfterToDate from './afterToDate'
import StartEndDate from './startEndDate'
import Nric from './nric'
import CreditCardExp from './creditCardExp'
import BdayRange from './bdayRange'
import DaysBeforeCover from './daysBeforeCover'
import StartBeforeToday from './startBeforeToday'
import ParamInput from './param'
import CheckSystemDate from './checkSystemDate'
import RequiredBlank from './requiredBlank'
import NotZero from './notZero'
import MinChar from './minChar'
import Sanction from './sanction'
import CheckExpDateLessEffDate from './checkExpDateLessEffDate'
import CheckEffDateMoreExpDate from './checkEffDateMoreExpDate'
import CheckAfterExpDate from './checkAfterExpDate'
import CheckBeforeEffDate from './checkBeforeEffDate'

export default function install() {
  Validator.extend('name', NameInput)
  Validator.extend('entry', EntryInput)
  Validator.extend('unit_no', UnitNo)
  Validator.extend('mask_decimal', MaskDecimal)
  Validator.extend('mask_min_value', MaskMinValue)
  Validator.extend('mask_max_value', MaskMaxValue)
  Validator.extend('from_to_date', FromToDate, { hasTarget: true })
  Validator.extend('after_to_date', AfterToDate, { hasTarget: true })
  Validator.extend('start_enddate', StartEndDate)
  Validator.extend('expdate_less_effdate', CheckExpDateLessEffDate)
  Validator.extend('effdate_more_expdate', CheckEffDateMoreExpDate)
  Validator.extend('after_expdate', CheckAfterExpDate)
  Validator.extend('before_effdate', CheckBeforeEffDate)
  Validator.extend('nric', Nric)
  Validator.extend('credit_card_exp', CreditCardExp)
  Validator.extend('bday_range', BdayRange)
  Validator.extend('days_before_cover', DaysBeforeCover)
  Validator.extend('start_before_today', StartBeforeToday)
  Validator.extend('param', ParamInput)
  Validator.extend('checkSystemDate', CheckSystemDate)
  Validator.extend('required_blank', RequiredBlank)
  Validator.extend('not_zero', NotZero)
  Validator.extend('min_char', MinChar)
  Validator.extend('sanction', Sanction)
}
